import React from 'react';
import ReactDOM from 'react-dom';
import * as Sentry from '@sentry/browser';

import './i18n';
import './styles/styles.scss';

import App from './components/App';

Sentry.init({
  dsn: 'https://240473d749bd4c4587ca1874568d2c27@sentry.io/1451229',
  environment: process.env.REACT_APP_ENV,
});

ReactDOM.render(<App />, document.getElementById('root'));
